import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { NEVER, take } from 'rxjs';

import { CurrentUserSelectors } from '@core/account-data';
import { FullCandidateActions } from '@core/candidate-data';
import { FeatureDiscoveryActions } from '@core/feature-discovery-data';
import { I18nService } from '@core/i18n-legacy';
import { createActionResponseFactory } from '@core/ngrx-legacy';
import { NotificationsController } from '@core/user-interface-legacy';

@Injectable({ providedIn: 'root' })
export class CandidateDataVisibilityService {
  private readonly store = inject(Store);
  private readonly notificationsController = inject(NotificationsController);
  private readonly i18n = inject(I18nService);

  public shouldSkipRevealConfirmation = this.store.selectSignal(
    CurrentUserSelectors.featureDiscovery({ feature: 'candidateProfileRevealSkipConfirm' }),
  );

  private actionFactory = createActionResponseFactory(FullCandidateActions);

  public toggleDataVisibility(candidateId: number, shouldBeVisible: boolean): void {
    const props = {
      payload: {
        candidateId,
      },
    };

    if (shouldBeVisible) {
      this.actionFactory(FullCandidateActions.revealCandidate, props, {
        successResponse: () => {
          this.notificationsController.success(
            this.i18n.translate('app.candidate.anonymization.candidate_revealed_for_you'),
          );
          return NEVER;
        },
      })
        .pipe(take(1))
        .subscribe();
    } else {
      this.store.dispatch(FullCandidateActions.hideCandidate(props));
    }
  }

  public saveDontAskForConfirmationAgain(): void {
    this.store.dispatch(
      FeatureDiscoveryActions.update({ payload: { candidateProfileRevealSkipConfirm: true } }),
    );
  }
}
